import { render } from "./ReportViewSection.vue?vue&type=template&id=07865be3"
import script from "./ReportViewSection.vue?vue&type=script&lang=js"
export * from "./ReportViewSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/ReportViewSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07865be3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07865be3', __exports__)) {
    api.reload('07865be3', __exports__)
  }
  
  module.hot.accept("./ReportViewSection.vue?vue&type=template&id=07865be3", () => {
    api.rerender('07865be3', render)
  })

}


export default __exports__